import * as Yup from 'yup';

export const verifyTotpSchema = Yup.object().shape({
    code: Yup.string().min(6).max(6).required(),
    setAsPreferred: Yup.boolean(),
});

export const verifyPhoneSchema = Yup.object().shape({
    smsSent: Yup.boolean(),
    phone: Yup.string().phone().required(),
    code: Yup.string()
        .min(6)
        .max(6)
        .when(['smsSent', 'verified'], {
            is: (smsSent, verified) => smsSent && !verified,
            then: schema => schema.required(),
        }),
    verified: Yup.boolean(),
    setAsPreferred: Yup.boolean(),
});
